module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "registros"
  }, [_h('div', {
    staticClass: "container"
  }, [_h('div', {
    staticClass: "row"
  }, [_h('h1', ["Listado de Registros"]), " ", _h('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(0), " ", _h('tbody', [_vm._l((_vm.registros), function(registro) {
    return _h('tr', {
      attrs: {
        "scope": "row"
      }
    }, [_h('td', [_vm._s(registro.nombre) + " " + _vm._s(registro.apellido)]), " ", _h('td', [_vm._s(registro.telefono)]), " ", _h('td', [_vm._s(registro.origen)])])
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _h('thead', {
    staticClass: "thead-inverse"
  }, [_h('tr', [_h('th', ["Nombre"]), " ", _h('th', ["Telefono"]), " ", _h('th', ["Origen"])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-166b3628!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Registros.vue
// module id = 196
// module chunks = 2